import React, { SVGProps } from 'react';

export const CanvaWhiteboard = ( props: SVGProps<SVGSVGElement> ) => (
	<svg
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{ ...props }
	>
		<rect width='24' height='24' rx='5' fill='#00C479' />
		<path
			d='M5 9V5h4'
			stroke='white'
			strokeWidth='1.75'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M19 9V5h-4'
			stroke='white'
			strokeWidth='1.75'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M5 15v4h4'
			stroke='white'
			strokeWidth='1.75'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M19 15v4h-4'
			stroke='white'
			strokeWidth='1.75'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
